import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { get_orders } from "../../store/reducers/orderReducer";
import { formatOrderDate } from "../../utils/orderDate";

const Orders = () => {
  const [state, setState] = useState("all");

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useSelector(state => state.auth);
  const { myOrders } = useSelector(state => state.order);

  useEffect(() => {
    dispatch(get_orders({ status: state, customerId: userInfo.id }));
  }, [state,dispatch, userInfo.id]);

  const redirect = ord => {
    let items = 0;
    for (let i = 0; i < ord.length; i++) {
      items = ord.products[i].quantity + items;
    }
    navigate("/pago", {
      state: {
        price: ord.price,
        items,
        orderId: ord._id,
      },
    });
  };

  return (
    <div className="bg-white p-4 rounded-md">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-slate-600">Mis Pedidos </h2>
        <select className="outline-none px-3 py-1 border rounded-md text-slate-600" value={state} onChange={e => setState(e.target.value)}>
          <option value="all">--Estado--</option>
          <option value="placed">Realizado</option>
          <option value="pending">Pendiente</option>
          <option value="cancelled">Cancelado</option>
          <option value="warehouse">Almacen</option>
        </select>
      </div>

      <div className="pt-4">
        <div className="relative overflow-x-auto rounded-md">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 uppercase bg-gray-200">
              <tr>
                <th scope="col" className="px-6 py-3">Código</th>
                <th scope="col" className="px-6 py-3">Fecha</th>
                <th scope="col" className="px-6 py-3">Precio</th>
                <th scope="col" className="px-6 py-3">Estado Pago</th>
                <th scope="col" className="px-6 py-3">Estado Pedido</th>
                <th scope="col" className="px-6 py-3">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {myOrders.map((o, i) => (
                <tr key={o._id} className="bg-white border-b">
                  <td className="px-6 py-4 font-mono font-bold text-[#ae1d22] whitespace-nowrap">
                    {o.orderCode || `#${o._id.slice(-6)}`}
                  </td>
                  <td  className="px-6 py-4 font-medium whitespace-nowrap">
                    {formatOrderDate(o)}
                  </td>
                  <td  className="px-6 py-4 font-medium whitespace-nowrap">
                    S/{o.price}
                  </td>
                  <td  className="px-6 py-4 font-medium whitespace-nowrap">
                    {o.payment_status}
                  </td>
                  <td  className="px-6 py-4 font-medium whitespace-nowrap">
                    {o.delivery_status}
                  </td>
                  <td  className="px-6 py-4 font-medium whitespace-nowrap">
                    <Link to={`/dashboard/order/details/${o._id}`}>
                      <span className="bg-green-200 text-[#ae1d22] text-md font-semibold mr-2 px-3 py-[2px] rounded">Ver</span>
                    </Link>

                    {o.payment_status !== "paid" && (
                      <span onClick={() => redirect(o)} className="bg-green-200 text-[#ae1d22] text-md font-semibold mr-2 px-3 py-[2px] rounded cursor-pointer">
                        Pagar
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Orders;
